<template>
  <v-container grid-list-md>
    <!-- <h1 class="text-h5">Detalhes do usuário</h1> -->
    <v-row>
      <v-col class="col-12 offset-0 col-md-8 offset-md-2 col-lg-4 offset-lg-4">
        <v-card class="profile-card">
          <v-card-title class="text-center align-start">
            <v-avatar class="profile elevation-2" color="grey" size="164">
              <v-img
                :src="`${user.avatar.replace('s50', 's150')}`"
              ></v-img>
            </v-avatar>
            <v-icon
              small
              class="mr-2"
              @click="editDialog = true" >
              mdi-pencil
            </v-icon>
          </v-card-title>
          <v-card-text class="text-center">
            <h1 class="text-h6">{{user.name}}</h1>
            <h2 class="text-body-1 mb-2">{{user.email}}</h2>
            <user-role-chip :role="user.acl" small />
            <p class="mt-3 mb-1">
              <b>Último login:</b>
              {{Moment(user.lastLogin).format('DD/MM/YYYY HH:mm')}}
            </p>
            <p class="mb-0">
              <b>Criado em:</b>
              {{Moment(user.createdAt).format('DD/MM/YYYY')}}
            </p>
          </v-card-text>
        </v-card>
        <v-card class="mt-3">
          <v-data-table
            :headers="headers"
            :loading="loading"
            :items="tokens"
            :items-per-page="20"
            class="elevation-1 mt-3"
            expand-icon="mdi-plus-circle"
            :group-desc="true"
            sort-by="nextRunAt"
            :sort-desc="true"
            :mobile-breakpoint="0"
          >
            <template v-slot:top>
              <v-toolbar dense flat color="white" class="pt-2">
                <v-toolbar-title class="text-body-2">Tokens de integração</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <div class="flex-grow-1"></div>
                <v-btn color="primary" dark class="mb-2" @click="newTokenDialog = true" small>Gerar token</v-btn>
              </v-toolbar>
            </template>

            <template v-slot:item.actions="{ item }">
              <span class="text-no-wrap">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" text icon x-small v-clipboard:copy="item.token">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Copiar Token</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn @click="revokeTokenDialog = true; revokeTokenId = item._id"
                    text icon v-on="on" color="red" x-small>
                      <v-icon>mdi-cancel</v-icon>
                    </v-btn>
                  </template>
                  <span>Cancelar Token</span>
                </v-tooltip>
              </span>
            </template>
            <template
              v-slot:item.createdAt="{ item }"
            >{{Moment(item.createdAt).format('DD/MM/YYYY')}}</template>
            <template v-slot:item.revokedBy="{ item }">
              <span class="text-no-wrap">{{item.revokedBy ? item.revokedBy.name : '---'}}</span>
            </template>
            <template v-slot:item.active="{ item }">
              <div class="state-col">
                <v-chip class="ma-2" color="green" text-color="white" v-if="item.active" small>Ativo</v-chip>
                <v-chip v-else class="ma-2" color="red" text-color="white" small>Bloqueado</v-chip>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- Edit Token Dialog -->
    <v-dialog v-model="editDialog" width="300">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2" primary-title>Editar Usuário</v-card-title>
        <v-card-text>
          <span class="text-body-1 d-block mb-1 mt-2">Grupo de usuário</span>
          <v-radio-group class="mt-0 mb-0" v-model="acl">
            <v-radio label="Usuário" value="user" />
            <!-- <v-radio label="Quant" value="quant" /> -->
            <v-radio label="Backoffice" value="backoffice" />
            <v-radio label="Admin" value="admin" />
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
            <v-btn color="success" @click="updateUser" text>Atualizar</v-btn>
            <div class="flex-grow-1"></div>
            <v-btn color="red" text @click="editDialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- New Token Dialog -->
    <v-dialog v-model="newTokenDialog" width="300">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2" primary-title>Gerar Token</v-card-title>
        <v-card-actions>
            <v-btn color="success" flat @click="generateNewToken">Gerar</v-btn>
            <div class="flex-grow-1"></div>
            <v-btn color="red" text @click="newTokenDialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Revoke Token Dialog -->
    <v-dialog v-model="revokeTokenDialog" width="300">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2" primary-title>Cancelar Token</v-card-title>
        <v-card-actions>
            <v-btn color="red" dark flat @click="revokeToken">Cancelar</v-btn>
            <div class="flex-grow-1"></div>
            <v-btn text @click="revokeTokenDialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
.profile-card {
  margin-top: 90px;
}
.profile {
  margin: auto;
  margin-top: -90px;
}
.state-col .v-chip {
  width: 90px;
  text-align: center;
  display: inline-block;
}
</style>

<script>
import moment from 'moment-loyall';

import api from '@/services/api';
import UserRoleChip from '@/components/global/UserRoleChip.vue';

export default {
  components: {
    UserRoleChip,
  },

  data: () => ({
    loading: true,
    Moment: moment,
    overview: {},
    user: {
      avatar: '',
    },
    n: '',
    tokens: [],
    newTokenDialog: false,
    revokeTokenDialog: false,
    revokeTokenId: '',
    editDialog: false,
    acl: '',
    headers: [
      { text: 'Ações', value: 'actions' },
      { text: 'Token Id', value: 'uid' },
      { text: 'Criado em', value: 'createdAt' },
      //   { text: 'Token', value: 'token' },
      { text: 'Estado', value: 'active' },
      { text: 'Bloqueado por', value: 'revokedBy' },
    ],
  }),

  async mounted() {
    await this.getData();
  },

  methods: {
    moment,
    async getData() {
      try {
        this.loading = true;
        const { id } = this.$route.params;
        const { data } = await api.users.byId(id);
        const { data: dataTokens } = await api.users.byIdIntegrationTokens(
          id,
        );
        this.user = data;
        this.acl = this.user.acl;
        this.tokens = dataTokens.tokens;
        this.loading = false;
      } catch (error) {
        this.$store.dispatch('notification', {
          text: error.response
            ? error.response.data.error.message
            : error.message,
          color: 'error',
          status: true,
        });
      }
    },

    async updateUser() {
      this.loading = true;
      await api.users.updateById(this.user._id, {
        acl: this.acl,
      });
      await this.getData();
      this.loading = false;
      this.editDialog = false;
    },

    async generateNewToken() {
      try {
        this.loading = true;
        await api.users.generateUserIntegrationToken(
          this.user._id,
        );
        this.loading = false;
        this.newTokenDialog = false;
        await this.getData();
      } catch (error) {
        // as
      }
    },

    async revokeToken() {
      try {
        this.loading = true;
        const { revokeTokenId } = this;
        await api.users.revokeUserIntegrationToken(
          this.user._id,
          revokeTokenId,
        );
        this.loading = false;
        this.revokeTokenDialog = false;
        await this.getData();
      } catch (error) {
        // as
      }
    },
  },
};
</script>
